import { ChangeDetectorRef, EventEmitter, Input, Output } from '@angular/core';
import { ControlValueAccessor } from '@angular/forms';
import { Observable, ReplaySubject } from 'rxjs';
import { coerceAttrBoolean } from '../utils/coercion';

/**
 * form control åé¨ä¸ä¿æ value å±æ§ï¼å½ä¸ä½¿ç¨ ngModel æ¶å¯ä»¥éè¿ [(value)] å®ç°ååç»å®ï¼
 * ä¹å¯ä»¥åå«ä¼ å¥ value å çå¬ valueChange äºä»¶ä»¥å®ç°é»æ­ç¨æ·æä½çåè½ã
 */
export abstract class CommonForm<T> implements ControlValueAccessor {
  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(val) {
    this._disabled = coerceAttrBoolean(val);
  }

  @Input()
  get value() {
    return this._value;
  }
  set value(val) {
    if (val === this._value) {
      return;
    }
    this._value = val;
    this.writeValue(val);
  }

  @Output()
  valueChange = new EventEmitter<T>();

  protected onChange: (_: T) => void;
  protected onTouched: () => void;
  protected value$$ = new ReplaySubject<T>(1);
  private _value: T;
  private _disabled = false;

  value$: Observable<T> = this.value$$.asObservable();

  constructor(protected cdr: ChangeDetectorRef) {}

  protected emitValueChange(value: T) {
    if (this.onChange) {
      this.value$$.next(value);
      this.onChange(value);
    }
    this.valueChange.emit(value);
  }

  registerOnChange(fn: (_: T) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    this.cdr.markForCheck();
  }

  abstract writeValue(value: T): void;
}
